import { render, staticRenderFns } from "./EmsHandwareProducts.vue?vue&type=template&id=3328bf3d"
import script from "./EmsHandwareProducts.vue?vue&type=script&lang=js"
export * from "./EmsHandwareProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports